import { Action, Reducer } from "redux";

export interface SelectedTabState {
  selectedTab: string;
}

export const defaultState = {
  selectedTab: "Expected"
} as SelectedTabState;

export interface SetSelectedTabAction {
  type: "SET_SELECTED_TAB";
  status: string;
}

export const actionCreators = {
  setSelectedTab: (status: string,  page: string) =>
    ({ type: "SET_SELECTED_TAB", status , page} as SetSelectedTabAction)
};

export const reducers: Reducer<SelectedTabState> = (
  state: SelectedTabState | undefined,
  incomingAction: Action
): SelectedTabState => {
  if (state === undefined) {
    return defaultState;
  }

  const action = incomingAction as SetSelectedTabAction;
  switch (action.type) {
    case "SET_SELECTED_TAB":
      return { selectedTab: action.status };
    default:
      return state;
  }
};
